import { render, staticRenderFns } from "./CmgIdMeVerificationModal.vue?vue&type=template&id=0b1a1ee4&scoped=true&lang=pug"
import script from "./cmg-id-me-verification-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-id-me-verification-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgIdMeVerificationModal.vue?vue&type=style&index=0&id=0b1a1ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a1ee4",
  null
  
)

export default component.exports